import { FsMatchTrack } from "db/model/match/Track/FsMatchTrack";
import { CupModePoints } from "model/Match/Set/CupMode/Format/CupModePoints";
import { CupModeTrack } from "model/Match/Set/CupMode/Track/CupModeTrack";
import { nonUndefined } from "Utility";
import { mapForwardCupModeRounds } from "./FsForwardCupModeRound";
import { Scores } from "model/Scores";
import { mapMatchTrackBase } from "db/mapping/match/Track/FsMatchTrack";
import { mapTrackRounds } from "db/mapping/match/Track/FsTrackRound";
import { Roster } from "model/Roster/Roster";
import { PlayTill } from "model/Match/Set/CupMode/Format/CupModeFormat";
import { RosterScope } from "model/Roster/RosterScope";

export const mapForwardCupModeTracks = (
  fsModels: FsMatchTrack[],
  rosters: Roster[],
  rosterScope: RosterScope,
  runningScores: Scores,
  points: CupModePoints,
  lastChance: boolean,
  pointsLimit: number,
  roundsPerTrack: number | undefined,
  driversPerTeam: number,
  requiredTeamWinners: number | undefined,
  playTill: PlayTill
) => {
  const completedDriverIds: string[] = [];
  const completedRosterIds: string[] = [];

  return nonUndefined(
    fsModels.map((t) =>
      mapForwardCupModeTrack(
        t,
        rosters,
        rosterScope,
        runningScores,
        points,
        lastChance,
        pointsLimit,
        roundsPerTrack,
        driversPerTeam,
        requiredTeamWinners,
        completedDriverIds,
        completedRosterIds,
        playTill
      )
    )
  );
};

const mapForwardCupModeTrack = (
  fsModel: FsMatchTrack,
  rosters: Roster[],
  rosterScope: RosterScope,
  runningScores: Scores,
  points: CupModePoints,
  finalist: boolean,
  pointsLimit: number,
  roundsPerTrack: number | undefined,
  driversPerTeam: number,
  requiredTeamWinners: number | undefined,
  completedDriverIds: string[],
  completedRosterIds: string[],
  playTill: PlayTill
): CupModeTrack | undefined => {
  const baseRounds = mapTrackRounds(nonUndefined(fsModel.rounds ?? []));
  const rounds = mapForwardCupModeRounds(
    baseRounds,
    rosters,
    rosterScope,
    runningScores,
    points,
    finalist,
    pointsLimit,
    driversPerTeam,
    requiredTeamWinners,
    playTill,
    completedDriverIds,
    completedRosterIds
  );

  return {
    ...mapMatchTrackBase(fsModel),
    isComplete: !!fsModel.overrideComplete
      ? true
      : !!roundsPerTrack && rounds.length >= roundsPerTrack,
    rounds,
  };
};
